import { useState } from "react";
import { z } from "zod";
import { useSearchParams, useNavigate } from "react-router-dom";
// import AboutEdit from "./about-edit";
// import { formatNumber } from "../../../utils/helpers";
import AboutEdit from "./about-edit";
import { formatNumber } from "../../../utils/helpers";

const formSchema = z.object({
  informationCollectionTool: z
    .string()
    .min(1, "information collection tool is required"),
  erpModule: z.string().min(1, "Data system is required"),
  systemDeveloper: z.string().min(1, "System developer name is required"),
  dateInstalled: z.string().min(1, "Installation date is required"),
  annualLicenseFee: z.string().min(1, "Annual license fees are required"),
  dataCollectionToolPurposeServe: z
    .string()
    .min(1, "Main purpose description is required"),
  annualLicenseFeeCurrency: z.string().min(1, "Currency is Required"),
});

type FormData = z.infer<typeof formSchema>;

const About = ({ data }) => {
  // If there's at least one record, use it
  const record = data;
  const [isEditing, setIsEditing] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/focal-person");
  };
  const handleNextPage = () => {
    setSearchParams({ tab: "data-collection" });
  };

  if (isEditing) {
    return (
      <AboutEdit
        data={data}
        setIsEditing={setIsEditing}
        // onEditSuccess={onEditSuccess}
      />
    );
  }

  return (
    <div className="font-Inter">
      {/* Card Header */}
      <div className="flex items-center gap-5 capitalize">
        <h2 className="font-semibold text-[#101828]">
          About {record.erpModule || "—"}
        </h2>
        <button
          className="text-[#2070B8] text-sm font-medium"
          onClick={() => setIsEditing(true)}
        >
          Edit Details
        </button>
      </div>

      {/* Card Content */}
      <div className="py-4 space-y-4">
        <div className="space-y-2">
          <label className="block text-sm font-medium text-[#3B3B3B]">
            Data system in use by the department{" "}
            <span className="text-[#3B3B3B]">*</span>
          </label>
          <p className="text-[#667085] text-sm font-medium capitalize">
            {record.erpModule || "—"}
          </p>
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-[#3B3B3B]">
            Name of the system developer *
          </label>
          <p className="text-[#667085] text-sm font-medium">
            {record.systemDeveloper || "—"}
          </p>
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-[#3B3B3B]">
            Date of first installation *
          </label>
          <p className="text-[#667085] font-medium text-sm">
            {record.dateInstalled || "—"}
          </p>
        </div>
        <div className="space-y-2">
          <label className="block text-sm font-medium text-[#3B3B3B]">
            Amount paid for annual license fees or maintenance *
          </label>
          <p className="text-[#667085] font-medium text-sm">
            {/* {record.dateInstalled || "—"}  */}
            {record.annualLicenseFee ? (
              <>
                {formatNumber(record.annualLicenseFee, {
                  currency: record.annualLicenseFeeCurrency,
                })}
              </>
            ) : (
              "—"
            )}
          </p>
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-[#3B3B3B]">
            Describe the main purpose of the system *
          </label>
          <p className="text-[#667085] text-sm font-medium">
            {record.systemPurpose || "—"}
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex gap-3 pt-6">
          <button
            onClick={handleBack}
            className="px-12 py-2.5 border border-[#D0D5DD] text-[#344054] font-medium rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
          >
            Go Back
          </button>
          <button
            type="button"
            onClick={handleNextPage}
            className="px-12 py-2.5 bg-[#2070B8] font-medium text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
          >
            Next Page
          </button>
        </div>
      </div>
    </div>
  );
};

export default About;
